import request from '@/utils/request'

export function getMenuListService() {
  return request({
    url: 'api/menu/list',
    method: 'get'
  })
}

export function getMenusService() {
  return request({
    url: '/api/menu/menus',
    method: 'get'
  })
}

export function editMenuService(data) {
  return request({
    url: 'api/menu/edit',
    method: 'post',
    data: data
  })
}

export function addMenuService(data) {
  return request({
    url: 'api/menu/add',
    method: 'post',
    data: data
  })
}

export function enableMenuService(data) {
  return request({
    url: 'api/menu/enable',
    method: 'get',
    params: data
  })
}

export function disableMenuService(data) {
  return request({
    url: 'api/menu/disable',
    method: 'get',
    params: data
  })
}

export function deleteMenuService(data) {
  return request({
    url: 'api/menu/delete',
    method: 'get',
    params: data
  })
}
